function log(...args) {
	const processedArgs = args.map(arg => {
		if (typeof arg === 'object' && arg !== null) {
			return JSON.stringify(arg, null, 2);
		}
		return arg;
	});
	console.log(...processedArgs);
}
export default  log